import { HistoryBadgeFilter } from '@components/HistoryBadgeFilter';
import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import type { CatalogUerBaseCostWorkScopeItems } from 'gql/graphql';
import { UerBaseCostChangeType } from 'gql/graphql';
import { cnMixSpace, Text } from 'uikit';

import type { RowClassRules } from 'ag-grid-community';

import Style from '../common/catalogUerBaseHistory.module.css';

import { usePriceHistoryColumns, usePriceHistoryData } from './hooks';

interface ICatalogUerBaseCostPriceHistoryProps {
    catalogId: string;
    catalogPriceName: string | undefined | null;
    historyRecordId: number;
    onClose: () => void;
}

const historyStylesRules: RowClassRules = {
    addedRowClass: ({ data }: { data: CatalogUerBaseCostWorkScopeItems }) =>
        Boolean(data?.changeType === UerBaseCostChangeType.New),
    updatedRowClass: ({ data }: { data: CatalogUerBaseCostWorkScopeItems }) =>
        Boolean(data?.changeType === UerBaseCostChangeType.Updated),
    deletedRowClass: ({ data }: { data: CatalogUerBaseCostWorkScopeItems }) =>
        Boolean(data?.changeType === UerBaseCostChangeType.Deleted),
};

export const CatalogUerBaseCostPriceHistory = ({
    catalogId,
    catalogPriceName,
    historyRecordId,
    onClose,
}: ICatalogUerBaseCostPriceHistoryProps) => {
    const { countsObj, tableRows, handleFilterChange, nameFilterData } = usePriceHistoryData({
        catalogUniqueId: catalogId,
        historyRecordId,
    });

    const columns = usePriceHistoryColumns({
        nameFilterData,
        handleFilterChange,
    });

    return (
        <ModalDialog
            isOpen
            title={
                <div className={Style.titleBlock}>
                    <Text
                        view="secondary"
                        lineHeight="l"
                        size="s"
                        weight="semibold"
                        transform="uppercase"
                        className={cnMixSpace({
                            mR: 's',
                        })}
                    >
                        состав работ: {catalogPriceName ?? ''}
                    </Text>
                    <HistoryBadgeFilter<UerBaseCostChangeType>
                        handlerBadgeFilterChange={handleFilterChange}
                        countsObj={countsObj}
                    />
                </div>
            }
            onClose={onClose}
            dockedToWindow="bottom"
            withTitleCloseButton
            isOnClickOutsideDisable
            withBottomButtons={false}
        >
            <div className={Style.modalBody}>
                <AgGridTable
                    className={Style.historyTable}
                    rowData={tableRows}
                    columnDefs={columns}
                    headerHeight={40}
                    rowClassRules={historyStylesRules}
                />
            </div>
        </ModalDialog>
    );
};

CatalogUerBaseCostPriceHistory.displayName = 'CatalogUerBaseCostPriceHistory';
